<template>
  <div v-if="isLoggedIn">
    <h4>YOU CANNOT ACCESS THIS PAGE WHILE LOGGED IN. PLEASE LOG OUT AND RE-OPEN THE LINK TO ACCESS.</h4>
  </div>
  <div v-else class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <PublicBrandHeader />
        <h3>Account Verification</h3>
        <form @submit.prevent="handleVerifyAccount">
          <div v-if="allFormErrors.length" class="form-error-summary" role="alert">
            <ul>
              <li v-for="(err, idx) in allFormErrors" :key="idx">{{ err }}</li>
            </ul>
          </div>
          <div class="row mb-2 gx-2">
            <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
              <input type="text" class="form-control" :value="accountTypeChild" disabled />
              <label class="profile_label">Account Type:</label>
            </div>
            <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
              <input type="text" class="form-control" v-model="form.externid" disabled />
              <label class="profile_label">ID #:</label>
            </div>
          </div>

          <div class="row mb-2 gx-2">
            <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
              <input type="text" class="form-control" v-model="form.first" required />
              <label class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>First Name:</label>
            </div>
            <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
              <input type="text" class="form-control" v-model="form.last" required />
              <label class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Last Name:</label>
            </div>
            <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
              <input
                type="text"
                class="form-control"
                v-model="form.login"
                required
                @keyup="validateUsername"
              />
              <label class="profile_label">Username:</label>
            </div>
          </div>

          <div class="row mb-2 gx-2">
            <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
              <input
               ref="pwd"
                 :type="showPassword ? 'text' : 'password'"
                class="form-control"
                v-model="form.password"
                required
                placeholder="Enter password"
                @change="validatePassword"
              />
              <button
                    type="button"
                    class="pwd-toggle"
                    @click="togglePassword"
                    @mousedown.prevent
                    :aria-pressed="showPassword"
                    :title="show ? 'Hide password' : 'Show password'"
                    style="background:none; border:none; position:absolute; top:15px; right:16px; cursor:pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
              <label class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Password:</label>
              
            </div>
            <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
              <input
               ref="pwd2"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                v-model="form.password2"
                required
                placeholder="Confirm password"
                @change="confirmPassword"
              />
              <button
                  type="button"
                  class="pwd-toggle"
                  @click="togglePassword"
                  @mousedown.prevent
                  :aria-pressed="showPassword"
                  :title="show ? 'Hide password' : 'Show password'"
                  style="background:none; border:none; margin-left:-36px; cursor:pointer;margin-left: 301px;margin-top: 0px;position: absolute;top: 15px;cursor: pointer;"
                  >
                  <!-- simple eye / eye-off SVG (swap based on show) -->
                  <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" stroke-width="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                    <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M1 12s4-7 11-7c2 0 3 .5 4 1.3" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  </button>
              <label class="profile_label"><span style="color:#ff0000;font-weight:600;">*</span>Confirm Password:</label>
              
            </div>
          </div>

          <div class="accountform-btn">
            <input type="submit" class="btn btn-primary" value="Verify Account" />
            <router-link to="/login" class="btn btn-secondary">Back to login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { h,ref } from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router/index";
import { CURR_API } from "@/constants/apis";
import $ from "jquery";
import { finalizeRegistration, updatePassword, updateUsername, isUserExist } from "@/api/userApi";
import { LoginNavigation } from "@/store/modules/fsm/messages";
import VALIDATION_ERRORS from "@/data/validationErrors";
import { getPasswordPolicyErrors } from "@/utils/passwordPolicy";
import { notPendingMessage, recheckPendingAccount } from "@/utils/pendingAccountStatus";
import { useRoute } from 'vue-router'; //Importing to Get Information Needed to Finalize User Account
import PublicBrandHeader from '@/components/public-layouts/PublicBrandHeader.vue';
const password = ref('')
const show = ref(false)
const pwd = ref(null)
const pwd2 = ref(null)
 //Get Query String Parameters value 
 const route = useRoute()
  
  const mysqlaccntVerified="";
export default {
  name: "verify-account-page",
  components: {
    PublicBrandHeader,
  },
  props: {
    accountType: {
      type: String,
      default: "",
    },
    unique: {
      type: String,
      default: "",
    },
    accntnum: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      accountTypeChild: this.accountType,
      // Username loaded from pending MySQL row; used to skip "already exists" for self.
      originalLogin: "",
      form: {
        accountnumber:"",
        externid: "",
        first: "",
        middle: "",
        last: "",
        login: "",
        email: "",
        password: "",
        password2: "",
        showPassword: false,
      },
      formErrors: {},
      mysqlaccntVerified: "",
    };
  },
  computed: {
    isLoggedIn: function () {
      return store.getters["login/isLoggedIn"];
    },
    /** Flattens formErrors into one list for the top-of-form error summary. */
    allFormErrors() {
      const out = [];
      for (const key in this.formErrors) {
        const fieldErrors = this.formErrors[key];
        if (Array.isArray(fieldErrors)) {
          for (const msg of fieldErrors) {
            if (msg) out.push(msg);
          }
        }
      }
      return out;
    },
  },
  beforeCreate() {
    if (this.isLoggedIn) {
      alert("Please logout to verify account");
      router.push({ name: LoginNavigation });
    }
    let isInit = this.$gotInitialMessage();
    if (!isInit) {
      let href = location.href + "";
      setTimeout(() => location.assign(href), 5000);
    }
  },
  created() {
    for (let key in this.form) {
      this.formErrors[key] = [];
    }
  },
  async mounted() {
    this.webHook({
      Account: {
        API_Meth: "GetPendingAccountInfo",
        accountype: this.accountTypeChild,
        uniqueNine: this.unique,
      },
    }).then((res) => {
      console.log("RETURNED ACCOUNT TYPE");
      console.log(res);
      if (res.data.status === "No Records Found") {
        router.push({ name: LoginNavigation });
        alert("There is an error with this verification link. Please request a new one.");
        return;
      }
      let dbData = (res.data.data && res.data.data[0]) || null;
      if (!dbData) {
        router.push({ name: LoginNavigation });
        alert("There is an error with this verification link. Please request a new one.");
        return;
      }
      if (dbData.account_status != "Pending") {
        router.push({ name: LoginNavigation });
        // Expired has its own sentence (utils/pendingAccountStatus.js).
        alert(notPendingMessage(dbData.account_status));
        return;
      }
      this.form.externid = dbData.unique_ID;
      this.form.login = dbData.username;
      this.originalLogin = dbData.username || ""; // baseline for change detection
      this.form.first = dbData.user_Fname;
      this.form.last = dbData.user_Lname;
      this.form.email = dbData.user_email;
      this.form.accountnumber = dbData.accountnumber;
    });
  },
  methods: {
    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    // Live username checks (format + uniqueness via existing isUserExist).
    async validateUsername() {
      const usernameRegex = /^([a-zA-Z]|_)+([a-zA-Z0-9_])*$/;
      this.form.login = (this.form.login || "").trim();
      this.formErrors.login = [];
      if (!usernameRegex.test(this.form.login)) {
        this.formErrors.login.push(VALIDATION_ERRORS.USERNAME_CHARACTERS);
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        this.formErrors.login.push(VALIDATION_ERRORS.USERNAME_LENGTH);
      }
      // Skip lookup when invitee keeps the provisional username from Add User.
      if (this.formErrors.login.length < 1 && this.form.login !== this.originalLogin) {
        try {
          const userExists = await isUserExist(this.form.login);
          // Assign (don't push) so overlapping isUserExist replies can't stack the same message.
          this.formErrors.login = userExists ? [VALIDATION_ERRORS.USERNAME_EXISTS] : [];
        } catch (err) {
          this.formErrors.login = [String(err?.message || err || "Unable to check username.")];
        }
      }
    },
    // Write new login to Postgres then MySQL before finalize/activate.
    async persistUsernameIfChanged() {
      const next = (this.form.login || "").trim();
      if (!next || next === this.originalLogin) {
        return; // no rename needed
      }
      // Postgres LA_user.ZV_user_login (login authority).
      await updateUsername({
        externid: this.form.externid,
        username: next,
      });
      // MySQL account_user (+ nurses.username when that row already exists).
      const mysqlRes = await this.webHook({
        Account: {
          API_Meth: "UpdatePendingAccountUsername",
          accountnumber: this.accntnum || this.form.accountnumber,
          uniqueNine: this.unique || this.form.externid,
          username: next,
        },
      });
      if (mysqlRes?.data?.status !== "200" && mysqlRes?.data?.message !== "Updated") {
        throw new Error(mysqlRes?.data?.message || "Unable to update username in organization records.");
      }
      this.originalLogin = next; // treat as current for any later checks
    },
    validatePassword() {
      this.formErrors.password = getPasswordPolicyErrors(this.form.password, [
        this.form.first,
        this.form.middle,
        this.form.last,
      ]);
      if (this.form.password2 && this.form.password2 !== "") {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
    togglePassword(event) {
    
    this.showPassword = !this.showPassword;
    // keep focus on the main password input
    this.$nextTick(() => {
      const el = this.$refs.pwd;
      if (el && el.focus) el.focus();
      const ell = this.$refs.pwd2;
      if (ell && ell.focus) ell.focus();
    });
  },
    async handleVerifyAccount() {
      await this.validateUsername(); // await so uniqueness errors block submit
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish verifying this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        { container: this.$el },
        { after: () => h("div", {}, "Verifying account...") }
      );

      try {
        // The invitation may have run out since the page opened (keyon's
        // PendingAccountExpiry): stop before pacmny-be gives her a login.
        const notPending = await recheckPendingAccount((request) => this.webHook(request), this.accountTypeChild, this.unique);
        if (notPending) {
          loader.hide();
          await this.$swal({ type: "warning", title: "Error", text: notPending });
          router.push({ name: LoginNavigation });
          return;
        }
        // Sequential awaits (vs old .then chain): each step must finish before the next,
        // and any failure jumps to catch so we don't activate with a half-updated username.
        await this.persistUsernameIfChanged(); // Postgres + MySQL rename before activate
        await finalizeRegistration(this.form.externid);
        await updatePassword({
          email: this.form.email,
          newPassword: this.form.password,
        });
        // keyon's activation, before any success is shown: it used to run
        // after the success alert, and a refusal was never seen.
        this.mysqlaccntVerified = await this.VerifyBackEndAccount();
        if (this.mysqlaccntVerified !== "Account Finalized") {
          throw new Error(
            "Your password is set, but we could not finish activating your account. Please contact your organization."
          );
        }
        loader.hide();
        await this.$swal({
          type: "success",
          title: "Success!",
          text: "Your account has been verified successfully and activated. You will now be redirected to login.",
        });
        router.push({ name: LoginNavigation });
      } catch (err) {
        loader.hide();
        this.$swal({
          type: "error",
          title: "Error",
          text: err?.message || String(err) || "Unable to verify account. Please try again.",
        });
        console.log("Logging the Finalized Validation Error");
        console.log(this.mysqlaccntVerified);
      }
    },
    /*Make our Account Update Here*/
    async VerifyBackEndAccount()
    {
      return this.webHook({
        Account: {
          API_Meth: "UpdatePendingAccountInfo",
          Accountstatus:"Active",
          uniqueNine: this.unique,
          accountnumber:this.accntnum || this.form.accountnumber
        },
      }).then((res) => {
        console.log("RETURNED VERIFIED ACCOUNT RESULT");
        console.log(res.data);
        if (res.data.message === "Updated" && !res.data.error) {
          // alert("Quic Notice Back-End Update Successfully.");
          return "Account Finalized"; //Returning 2nd (mysql update status). This should now make the account active and should reroute user next time
        }
        if(res.data.error && res.data.error !="")
        {
          //log the error 
          console.log("Logging Finalization Error");
          console.log(res.data.error);
          return "Account Not Finalized"; //return message for error
        }
       
      }).catch((err) => {
        console.log("Logging Finalization Error");
        console.log(err);
        return "Account Not Finalized";
      });
   },
    async webHook(request) {
      return await axios.post(CURR_API + "/tswebhook.php", request, {
        headers: { "Content-Type": "application/json;" },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";

.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed;
  background-size: cover;
  position: relative;
}

.reset-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.reset {
  background-color: #fff;
  padding: 2rem;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  @include absoluteCenter(760px);

  > h3 {
    text-align: center;
  }
}

.accountform-btn {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.form-error-summary {
  margin: 0.75rem 0 1.5rem;
  padding: 0.9rem 1.15rem;
  background: #fdecea;
  border: 1px solid #f3b4b0;
  border-radius: 6px;
}

.form-error-summary ul {
  margin: 0;
  padding-left: 1.1rem;
  color: #9b2c2c;
}

.form-error-summary li {
  margin: 0.15rem 0;
}

@media only screen and (max-width: 768px) {
  .reset {
    width: 95%;
  }
}
</style>
